import './shared';
import './modules/front';
import React from 'react';
import ReactDOM from 'react-dom';
import ItemDatePicker from './modules/front/ItemDatePicker';
import OrderItemPackageButton from './modules/front/OrderItemPackageButton';

// Bootstrap
import './modules/front/scss/main.scss'
import ReservationExternal from "@/modules/front/ReservationExternal/ReservationExternal";
//import 'bootstrap/scss/bootstrap.scss';


// Webpack HMR

if (module.hot) {
	module.hot.accept();
}

document.addEventListener('DOMContentLoaded', () => {
	const e = React.createElement;
	const domContainer = document.querySelectorAll('.item_date_picker_container');

	for (let i = 0; i < domContainer.length; i++) {
		const root = ReactDOM.createRoot(domContainer[i]);
		root.render(React.createElement(ItemDatePicker, {
			'locale': domContainer[i].getAttribute('data-locale'),
			'seasonId': domContainer[i].getAttribute('data-season-id'),
			'offices': JSON.parse(domContainer[i].getAttribute('data-offices')),
			'office': domContainer[i].getAttribute('data-office'),
			'lockOffice': domContainer[i].getAttribute('data-lock-office'),
			'variants': JSON.parse(domContainer[i].getAttribute('data-variants') || '[]'),
			'itemId': domContainer[i].getAttribute('data-item-id'),
			'from': domContainer[i].getAttribute('data-from'),
			'to': domContainer[i].getAttribute('data-to'),
			'showModal': domContainer[i].getAttribute('data-show-modal'),
		}));

	}

	const orderItemPackageButton = document.querySelectorAll('.component-order-item-package-button');
	for (let i = 0; i < orderItemPackageButton.length; i++) {
		const root = ReactDOM.createRoot(orderItemPackageButton[i]);
		root.render(React.createElement(OrderItemPackageButton, {
			'locale': orderItemPackageButton[i].getAttribute('data-locale'),
			'packageId': orderItemPackageButton[i].getAttribute('data-package-id'),
			'lengthHours' : orderItemPackageButton[i].getAttribute('data-length-hours'),
			'offices': JSON.parse(orderItemPackageButton[i].getAttribute('data-offices')),
			'office': orderItemPackageButton[i].getAttribute('data-office'),
			'lockOffice': orderItemPackageButton[i].getAttribute('data-lock-office'),
			'openModal': orderItemPackageButton[i].getAttribute('data-open-modal'),
		}));
	}

	const reservationExternal = document.querySelectorAll('.component-reservation-external');
	for (let i = 0; i < reservationExternal.length; i++) {
		const root = ReactDOM.createRoot(reservationExternal[i]);
		root.render(React.createElement(ReservationExternal, {
			'itemId': reservationExternal[i].getAttribute('data-item-id'),
			'itemTitle': reservationExternal[i].getAttribute('data-item-title'),
			'locale': reservationExternal[i].getAttribute('data-locale'),
			'seasonId': reservationExternal[i].getAttribute('data-season-id'),
			'offices': JSON.parse(reservationExternal[i].getAttribute('data-offices')),
			'office': reservationExternal[i].getAttribute('data-office'),
			'lockOffice': reservationExternal[i].getAttribute('data-lock-office'),
			'termsUrl': reservationExternal[i].getAttribute('data-terms-url'),
			'gdprUrl': reservationExternal[i].getAttribute('data-gdpr-url'),

		}));
	}

});



